export default {"id":"icon-split-arrow"}